import { Box, Button } from '@mui/material'
import { useAuthentications } from 'contexts/authentications'
import { IMyConnectorsDTO } from 'data/dtos/automation/i-custom-connector-dto'
import { useHistory } from 'react-router-dom'
import { onShowExpirationDate } from 'utils/date'
import { getIcon } from 'utils/get-icon'
import TableStatus from '../table-status'
import { useStyles } from './styles'

const AuthenticationTables = () => {
  const { connectors, validate, refetchValidate } = useAuthentications()
  const classes = useStyles()
  const history = useHistory()

  const handleNavigate = (connector: IMyConnectorsDTO, connectors: IMyConnectorsDTO[]) => {
    if (connector.name === 'E-Social') {
      const snowFlakeConnector = connectors.find((c) => c.name === 'snowflake')

      history.push(`/authentications/${snowFlakeConnector?.id}/${connector.name}`)
    }
  }

  return (
    <>
      <Box className={classes.root}>
        <Box className={classes.headerContainer}>
          <Button
            type='button'
            variant='contained'
            className={classes.newAuthenticationnButton}
            disabled
          >
            Nova autenticação
          </Button>
        </Box>

        <table className={classes.tableBase}>
          <thead className={classes.tableHeader}>
            <tr>
              <th className={classes.tableSize}>Nome</th>
              <th className={classes.tableSize}>Tipo</th>
              <th className={classes.tableSize}>Data de expiração</th>
              <th className={classes.tableSize}>Status</th>
            </tr>
          </thead>

          <tbody className={classes.tableBody}>
            {connectors.map((connector: IMyConnectorsDTO, index: number) => {
              if (connector.name === 'snowflake') {
                return null
              }

              const isESocial = connector.name === 'E-Social'
              const isValid = validate !== null

              return (
                <tr
                  key={index}
                  onClick={() => handleNavigate(connector, connectors)}
                >
                  <td className={classes.tableSize}>
                    <Box className={classes.nameContainer}>
                      <Box className={classes.iconContainer}>{getIcon(connector.name)}</Box>
                      <span>{connector.name}</span>
                    </Box>
                  </td>

                  <td className={classes.tableSize}>
                    <span>{connector.type === 'output' ? 'Saida de dados' : 'Entrada de dados'}</span>
                  </td>

                  <td className={classes.tableSize}>
                    {connector.name === 'E-Social' && onShowExpirationDate(validate)}
                  </td>

                  <td className={classes.tableSize}>
                    {isESocial ? (
                      <TableStatus status={isValid ? 'authorized' : ''} />
                    ) : (
                      <TableStatus status={connector.status} />
                    )}
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </Box>
    </>
  )
}

export default AuthenticationTables
